import { Div } from '@codesuma/baseline'
import { ChoiceSlide, IChoice } from '../../components/wizard'
import { IDayCell } from '../../services/calendar'
import { Repeat } from '../../services/occasion-repeat'
import { J_MONTHS, G_MONTHS, H_MONTHS } from '../../configs/names'
import { toFaDigits } from '../../helpers/digits'
import { Draft } from './draft'
import { leapDayMessage } from './leap-day'
import style from './index.module.css'

export const OccasionRepeatSlide = (draft: Draft) => {
    const base = ChoiceSlide('آیا تکرار می‌شود؟', [
        { value: 'none', label: 'تکرار نمی‌شود' },
        { value: 'yearly', label: 'هر سال' },
    ], draft.occasionRepeat === 'none' ? 'none' : 'yearly')
    let calendar: Repeat = draft.occasionRepeat === 'none' ? 'jalaali' : draft.occasionRepeat
    base.on('pick', (value: string) => {
        if (draft.occasionRepeat !== 'none') calendar = draft.occasionRepeat
        draft.occasionRepeat = value === 'none' ? 'none' : calendar
        base.emit('change')
    })
    return base
}

export const CalendarSlide = (draft: Draft, day: IDayCell) => {
    const choices: IChoice<Repeat>[] = [
        { value: 'jalaali', label: 'هجری شمسی', note: toFaDigits(`${day.jd} ${J_MONTHS[day.jm - 1]}`) },
        { value: 'gregorian', label: 'میلادی', note: toFaDigits(`${day.gd} ${G_MONTHS[day.gm - 1]}`) },
        { value: 'hijri', label: 'هجری قمری', note: toFaDigits(`${day.hd} ${H_MONTHS[day.hm - 1]}`) },
    ]
    const base = ChoiceSlide('بر اساس کدام تقویم؟', choices, draft.occasionRepeat)
    const note = Div()
    note.addClass(style.hint)
    note.attr('role', 'status')
    const refresh = () => {
        const message = leapDayMessage(draft.occasionRepeat, day)
        note.text(message)
        note.style({ display: message ? '' : 'none' })
    }
    base.on('pick', (value: Repeat) => {
        draft.occasionRepeat = value
        refresh()
        base.emit('change')
    })
    base.append(note)
    refresh()
    return base
}
